import { render, staticRenderFns } from "./DataSetViewEngine.vue?vue&type=template&id=2267a482&scoped=true"
import script from "./DataSetViewEngine.vue?vue&type=script&lang=js"
export * from "./DataSetViewEngine.vue?vue&type=script&lang=js"
import style0 from "./DataSetViewEngine.vue?vue&type=style&index=0&id=2267a482&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2267a482",
  null
  
)

export default component.exports